<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/_main'
import PageHeader from '@components/page-header'

import { deviceApi } from '@router/apiFiles/deviceApi'
import { customerApi } from '@router/apiFiles/customerApi'

export default {
	page: {
		title: 'Create Group',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: {
		Layout,
		PageHeader,
	},
	data() {
		return {
			items: [
				{
					text: 'OnBoard',
					href: '/',
				},
				{
					text: 'Devices',
					href: '/',
				},
				{
					text: 'Create Group',
					active: true,
				},
			],
			isBusy: false,
			name: '',
			description: '',
			endpoint: '',
			endpointToken: '',
			customerId: '',
			currentUser: null
		}
	},
	mounted() {
		const currentUserData = localStorage.getItem('auth.currentUser');
		if (currentUserData) {
			this.currentUser = JSON.parse(currentUserData);
		}
		this.fetchData().catch(error => {
			console.error(error)
		})
	},
	methods: {
		async fetchData() {
			let self = this;
			this.isBusy = true
			customerApi.searchCustomers({ search: '', page: 1, perPage: 50 })
				.then(function (data) {
					self.customers = data.data;
					self.isBusy = false
				});
		},
		save() {
			var self = this;
			self.isBusy = true;
			self.show = false;
			deviceApi.createDeviceGroup({
				name: self.name,
				description: self.description,
				endpoint: self.endpoint,
				endpointToken: self.endpointToken,
				customerId: self.customerId
			})
				.then(function (data) {
					self.isBusy = false;
					self.$router.push('/searchgroups');
				});
		},

	}
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<b-overlay :show="isBusy">
			<div class="row">

				<div class="col-lg-6">
					<div class="card">
						<div class="card-body">
							<h4 class="header-title mb-3">Create Group</h4>

							<div class="row">
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Name</h5>
										<b-form-input v-model="name"></b-form-input>
									</div>
								</div>
								<!-- Customer -->
								<div v-if="currentUser && currentUser.role == '1'" class="col-lg-6">
									<div class="form-group">
										<label>Customer</label>
										<div>
											<select class="form-control" v-model="customerId"
												style="max-width:100%">
												<option v-for="customer of customers" v-bind:key="customer.id"
													v-bind:value="customer.id">{{ customer.name }}</option>
											</select>
										</div>
									</div>
								</div>
								<!-- End Customer -->
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="mb-4">
										<h5 class="mt-0">Description</h5>
										<b-form-input v-model="description"></b-form-input>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="mb-4">
										<h5 class="mt-0">Endpoint</h5>
										<b-form-input v-model="endpoint"></b-form-input>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="mb-4">
										<h5 class="mt-0">Token</h5>
										<b-form-input v-model="endpointToken"></b-form-input>
									</div>
								</div>
							</div>


							<div class="row">
								<div class="col-lg-12">
									<a href="javascript: void(0);" @click="save()"
										class="btn btn-primary btn-sm float-right">Save<i class="uil uil-edit ml-1"></i></a>
								</div>
							</div>

						</div>
					</div>
				</div>

			</div>


		</b-overlay>
	</Layout>
</template>
